export default "__VITE_ASSET__CbBhpO9V__"